import { useNavigate } from 'react-router';

import { Button } from 'ui';

import { StandaloneTeacherSearchFilters } from './TeacherSearchFilters';
import classes from '../Teacher.module.scss';

export const TeacherSearchError = () => {
  const navigate = useNavigate();

  return (
    <>
      <main className={classes['teacher-search-error']}>
        <h1>Подсказка:</h1>
        <p>
          Сейчас поиск от вас скрыт, необходимо подтвердить паспорт и заполнить профиль,
          чтобы вы могли откликаться на задачи и ваш профиль был показан в выдаче.
        </p>
        <div>
          <Button
            onClick={() => navigate('/teacher/search/error-two')}
            variant={'filled'}
            size={'md'}
            shape={'brick'}
            color={'primary'}
          >
            Продолжить
          </Button>
        </div>
      </main>
      <StandaloneTeacherSearchFilters />
    </>
  );
};
